import { roundNumber } from '@ztechapps/common.utils'

/** The carrier's absolute floor for a shipment's declared value. */
export const MINIMUM_INSURED_AMOUNT = 100

/**
 * Defaults the shipment's declared value from the order subtotal, floored at
 * the carrier's $100 minimum, so a shopper never ships insured for less than
 * their order is worth without deliberately lowering it.
 */
export const computeDefaultInsuredAmount = (gross?: number): number =>
  Math.max(MINIMUM_INSURED_AMOUNT, roundNumber(gross ?? 0, 2))
